// @flow
import { CHANGE_LAYOUT, TOGGLE_LEFTMENU } from "./actionTypes";

const INIT_STATE = {
  layoutType: "horizontal",
  leftMenu: false,
};

const Layout = (state = INIT_STATE, action) => {
  let newState = state;
  switch (action.type) {
    case CHANGE_LAYOUT:
      newState = {
        ...state,
        layoutType: action.payload,
      };
      break;
    case TOGGLE_LEFTMENU:
      newState = {
        ...state,
        leftMenu: action.payload,
      };
      break;
    default:
      break;
  }
  return newState;
};

export default Layout;
